

// const webServiceBaseUrl = "http://localhost:51585/api/";
const webServiceBaseUrl = "https://api.teknolabatmserver.com/api/";

// FetchApiGetwithUrl(webServiceUrl, SuccessCallbackFunction, ErrorCallbackFunction) {

//     var urlParameters = jQuery.param(data);
//     var urlData = '?' + urlParameters;       

//     fetch(webServiceUrl + urlData)
//         .then((response) => response.json())
//         .then(kullaniciGirisiResultModel => {
//             SuccessCallbackFunction(data);
//             console.log(kullaniciGirisiResultModel);

//             this.lokasyonlarSayfasinaGit(kullaniciGirisiResultModel);
//         })

//         .catch(function (error) {

//             ErrorCallbackFunction(error);
//         });
// };

export const FetchApiGet = (webServiceMethod, Parameters, SuccessCallbackFunction, ErrorCallbackFunction) => {
    const webServiceUrl = webServiceBaseUrl + webServiceMethod;
    const urlParameters = '?' + new URLSearchParams(Parameters).toString();
    const webServiceUrlWithParameters = webServiceUrl + urlParameters;

    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + sessionStorage.getItem('Token')
        },
        mode: 'cors', // ✨ CORS için gerekli
        // credentials: 'include' // ✨ Eğer oturum çerezi, token vb. gerekiyorsa
    };

    fetch(webServiceUrlWithParameters, options)
        .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        })
        .then(data => SuccessCallbackFunction(data))
        .catch(error => ErrorCallbackFunction(error));
};


export const FetchApiPost = (webServiceMethod, data, SuccessCallbackFunction, ErrorCallbackFunction) => {
    const webServiceUrl = webServiceBaseUrl + webServiceMethod;

    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + sessionStorage.getItem('Token')
        },
        body: JSON.stringify(data),
        mode: 'cors', // ✨ CORS ayarı
        // credentials: 'include' // ✨ (eğer gerekiyorsa)
    };

    fetch(webServiceUrl, options)
        .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        })
        .then(data => SuccessCallbackFunction(data))
        .catch(error => ErrorCallbackFunction(error));
};


// FetchApiFilePost(webServiceUrl, data, SuccessCallbackFunction, ErrorCallbackFunction) {


//     const options = {
//         method: 'POST',
//         body: data
//     };

//     fetch(webServiceUrl, options)
//         .then((response) => response.json())
//         .then(function (data) {

//             SuccessCallbackFunction(data);
//         })
//         .catch(function (error) {

//             ErrorCallbackFunction(error);
//         });
// }


export default FetchApiGet;